import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowDown, ArrowRight, X } from "lucide-react";

export default function PreOfferBanner({ ctaHref = "/ebook#cage-sale", ctaLabel = "Get the free book" }) {
  const [showAnswer, setShowAnswer] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  return (
    <>
      {/* BANNER */}
      {!dismissed && (
        <div
          className="fixed bottom-0 left-0 right-0 z-40 bg-paper/95 backdrop-blur-md border-t border-hairline shadow-[0_-8px_30px_rgba(10,10,10,0.04)]"
          data-testid="pre-offer-banner"
        >
          <button
            type="button"
            onClick={() => setDismissed(true)}
            aria-label="Dismiss"
            className="absolute top-3 right-4 md:top-4 md:right-6 p-1.5 text-muted hover:text-ink transition-colors"
            data-testid="pre-offer-banner-close"
          >
            <X size={18} strokeWidth={1.5} />
          </button>

          <button
            type="button"
            onClick={() => setShowAnswer(true)}
            className="group block w-full text-left bg-transparent border-0 p-0 cursor-pointer"
            data-testid="pre-offer-banner-trigger"
          >
            <div className="max-w-screen-xl mx-auto px-6 md:px-12 py-6 md:py-7 grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-10 items-center">
              <div className="md:col-span-2 label-mono text-muted">The question</div>
              <h2 className="md:col-span-8 font-display text-xl sm:text-2xl md:text-[1.75rem] lg:text-3xl leading-[1.15] tracking-tight text-ink group-hover:text-leaf transition-colors">
                What if the problem was never your strategy?
              </h2>
              <div className="md:col-span-2 md:text-right label-mono text-muted group-hover:text-leaf transition-colors flex items-center md:justify-end gap-2">
                Tap to see the answer
                <ArrowDown size={14} strokeWidth={1.75} />
              </div>
            </div>
          </button>
        </div>
      )}

      {/* ANSWER MODAL */}
      {showAnswer && (
        <div
          className="fixed inset-0 z-50 bg-paper/95 backdrop-blur-md overflow-y-auto"
          onClick={() => setShowAnswer(false)}
          data-testid="answer-modal"
        >
          <button
            type="button"
            onClick={() => setShowAnswer(false)}
            aria-label="Close"
            className="fixed top-5 right-5 md:top-8 md:right-8 z-10 p-3 text-ink hover:text-leaf transition-colors"
            data-testid="answer-modal-close"
          >
            <X size={24} strokeWidth={1.5} />
          </button>

          <div
            className="min-h-screen flex items-center justify-center px-6 md:px-12 py-24"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="max-w-3xl w-full">
              <div className="label-mono text-muted text-center">The answer</div>
              <h2 className="font-display mt-8 text-4xl sm:text-5xl md:text-6xl lg:text-[4.5rem] leading-[1.04] tracking-tight text-center text-ink">
                What if the problem was never your strategy?
              </h2>
              <div className="mt-12 mx-auto w-12 h-[1px] bg-hairline" />
              <div className="mt-12 text-lg md:text-xl text-muted leading-[1.9] space-y-6">
                <p>Most traders already know what they should do. The challenge is executing it when pressure, fear, urgency and ego take over.</p>
                <p>THE CAGE maps what happens when a working edge becomes unexecutable under pressure, and the structure built to contain it.</p>
              </div>

              <div className="mt-14 flex flex-col sm:flex-row items-center justify-center gap-6">
                <Link
                  to={ctaHref}
                  onClick={() => setShowAnswer(false)}
                  className="group inline-flex items-center gap-3 bg-ink text-white px-8 py-4 label-mono hover:bg-leaf transition-colors"
                  data-testid="answer-modal-cta"
                >
                  {ctaLabel} <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
                </Link>
                <button
                  type="button"
                  onClick={() => setShowAnswer(false)}
                  className="label-mono text-muted hover:text-ink transition-colors"
                  data-testid="answer-modal-dismiss"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
